import type { Maybe } from '@pylot-data/pylotschema'
import { PylotFrontendConfig, ModelType } from 'config'

export const buildModelUrl = (
    modelType: ModelType,
    url_key: Maybe<string>,
    config: PylotFrontendConfig,
    absolute = true
): string => {
    const { directory, suffix } = config.base.url.model[modelType] ?? {}
    const baseUrl = absolute ? config.base.url.baseUrl : '/'
    return `${baseUrl}${directory}/${url_key}${suffix}`
}
